// extracted by mini-css-extract-plugin
export default {"whatsappFloat":"whatsapp_whatsappFloat__Rf1Ub","icon":"whatsapp_icon__bH4yb"};